import React, { memo } from "react";

import Typography from "../common/Typography/Typography";

const Footer = () => {
    const year = new Date().getFullYear();

    return (
        <footer className="p-2 text-center">
            <Typography>All Content © Vergo UK Ltd {year}</Typography>
        </footer>
    );
};

export default memo(Footer);
